import { render, staticRenderFns } from "./GlobalSelection.vue?vue&type=template&id=3adc89d6&name=global-selection&"
import script from "./GlobalSelection.vue?vue&type=script&lang=js&"
export * from "./GlobalSelection.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports